import React, { useContext } from 'react';

import { useHistory } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const ChillerFormSubmitDialog: React.FC = () => {
  const history = useHistory();

  let { submitDialogOpen, chillerLog } = useContext(ChillerLogsContext);

  let message = 'Chiller log submitted for approval!';
  if (chillerLog?.status === 'approved') {
    message = 'Chiller log approved!';
  }

  return (
    <Dialog
      open={submitDialogOpen}
      onClose={() => window.location.reload()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Success!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.location.reload()}>Stay On Job Page</Button>
        <Button onClick={() => history.push('/chiller_logs/search')}>Return to Jobs List</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChillerFormSubmitDialog;
